import React from 'react';
import { maxReportNumberDecimalPlaces } from './ReportsConstants';

export function createPdfWithPopupBlockerHandler(
  pdfMakeInstance,
  pdfDefinition,
  fileName,
  saveReport,
  onPopupBlocked,
) {
  if (saveReport) {
    pdfMakeInstance.createPdf(pdfDefinition).download(`${fileName}.pdf`);
  } else {
    const pdfWindow = window.open('', '_blank');
    if (!pdfWindow) {
      if (onPopupBlocked) {
        onPopupBlocked();
      }
      return;
    }
    pdfMakeInstance.createPdf(pdfDefinition).open({}, pdfWindow);
  }
}

export function showPopupBlockedModal(
  showModalSimple,
  setPopupBlockedModal,
  hideModal,
  message = 'Unable to preview report. Please make sure pop-ups and redirects are allowed then try again.',
  title = 'Report Preview Failed',
) {
  showModalSimple({
    body: message,
    customHeader: (
      <div className="px-6 py-4 flex items-center font-roboto text-xl leading-[120%] font-normal text-[#f7a246]">
        {title}
      </div>
    ),
    okButtonText: 'OK',
    isOkOnly: true,
    hideCloseButton: true,
    onOk: () => {
      if (setPopupBlockedModal) {
        setPopupBlockedModal(false);
      }
      hideModal();
    },
  });
}

export function roundToMaxDecimals(value: number): number {
  const factor = Math.pow(10, maxReportNumberDecimalPlaces);
  return Math.round(value * factor) / factor;
}

export const IMAGER_TEMP_PROP_NAME = 'ImagerTemperature';
export const IMAGER_TEMP_NAME = 'Imager Temperature';
